import React, { useEffect } from 'react';
import Header from './header';
import Footer from './footer';
import { Link, useNavigate } from "react-router-dom";

function ConsultaCancelada() {
    const navigate = useNavigate();

    useEffect(() => {
        // Redirigir a la agenda tras 1000ms
        const timer = setTimeout(() => {
            navigate("/agenda");
        }, 2000);

        // Limpiar el timer para evitar fugas de memoria
        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <>
            <Header active="Agenda" />
            <div style={{ textAlign: 'center', marginTop: '50px' }}>
                <h1>Consulta Cancelada</h1>
                <p>Redirigiendo a la agenda...</p>
                <Link to="/">
                    <button className='volverIndex'>Volver</button>
                </Link>
            </div>
            <Footer />
        </>
    );
}

export default ConsultaCancelada;